




















import { Component, Emit, Vue } from 'vue-property-decorator'

import { AddNewFlowAction } from './types'

@Component({
  data() {
    return {
      AddNewFlowAction,
    }
  },
})
export default class FlowPageTitleButtons extends Vue {

  @Emit()
  selectAction(action: AddNewFlowAction): AddNewFlowAction {
    return action
  }
}
